/**
 * å¼ç¨çåæ°æ®structureä¿¡æ¯
 */
export class RefStructureInfo {

    /**
     * structureInfoçå¯ä¸æ è¯
     */
    id: string;

    /**
     * structureæå±åæ°æ®çç±»åå¨ç§°ï¼å¦GSPViewModel
     */
    referType: string;

    /**
     * æå±åæ°æ®id
     */
    referId: string;

    /**
     * æå±åæ°æ®Code
     */
    referCode: string;


    /**
     * å¼ç¨çstucturedType Id
     */
    structuredTypeId: string

    /**
     * å¼ç¨çå¯¹è±¡çCode
     */
    code: string;

    /**
     * å¼ç¨çå¯¹è±¡çName
     */
    name: string;

}